import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'
import type { EventsType } from '$lib/types/client_types'

const store = writable([] as EventsType[])
export { store as storeEventsTypes }

let promiseFetch: Promise<EventsType[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

// return true if initialized now
export async function InitEventsTypes(pFetch = fetch) {
	if (!browser) return fetchData(pFetch)
	if (state === 'ready') return
	if (state === 'reading') {
		await promiseFetch
		return
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return
}

async function fetchData(pFetch = fetch) {
	state = 'reading'

	// const jsonData = await apiGetJson('/lookup/events_types')
	const jsonData = await apiFetchJson(pFetch, 'get', '/lookup/events_types')
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return
	}

	const data = jsonData.events_types
	if (browser) {
		store.set(data)
		state = 'ready'
	}

	return data
}

// UP generic ==== Down custom ===================

export function getEventType(eventType_id: number) {
	const allEventsTypes = get(store)
	const eventsType = allEventsTypes.find((co) => co.id === eventType_id)
	if (eventsType) return eventsType

	return {
		id: -1,
		name: '',
		title: '',
		body: ''
	}
}
